module.exports = __webpack_public_path__ + "img/job-professional.2482e449.svg";